import script from "./AddStage.vue?vue&type=script&setup=true&lang=js"
export * from "./AddStage.vue?vue&type=script&setup=true&lang=js"

import "./AddStage.vue?vue&type=style&index=0&id=6bdf33df&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bdf33df"]])

export default __exports__